<template>
  <Header />
  <MainSlider1 />
  <!-- <Offer /> -->
  <Models />
  <MainSlider2 />
  <InStock />
  <KnowMore />
  <AboutUs />
  <TeamComponent />
  <Service />
  <MobileApp />
  <Advantages />
  <YandexMapComponent />
  <ContactFormComponent />
  <FooterComponent />
  <RequestFormComponent />
  <PrivacyComponent />
  <AgreeProcessingComponent />
  <CallPopupComponent />
</template>

<script>
import Header from "./components/header/HeaderComponent.vue";
import RequestFormComponent from "./components/request-form/RequestFormComponent.vue";
import MainSlider1 from "./components/main-slider-1/MainSliderComponent.vue";
import MainSlider2 from "./components/main-slider-2/MainSliderComponent.vue";
import Models from "./components/models-range/ModelsComponent.vue";
import InStock from "./components/in-stock/TabsComponent.vue";
import KnowMore from "./components/know-more/KnowMoreComponent.vue";
import AboutUs from "./components/about-us/AboutUsComponent.vue";
import TeamComponent from "./components/team/TeamComponent.vue";
import Service from "./components/service-section/ServiceComponent.vue";
import MobileApp from "./components/mobile-app/MobileAppComponent.vue";
import Advantages from "./components/advantages/AdvantagesComponent.vue";
import YandexMapComponent from "./components/yandex-map/YandexMapComponent.vue";
import ContactFormComponent from "./components/contact-form/ContactFormComponent.vue";
import FooterComponent from "./components/footer/FooterComponent.vue";
import PrivacyComponent from "./components/privacy/PrivacyComponent.vue";
import Offer from "./components/offer/Offer.vue";
import AgreeProcessingComponent from "./components/privacy/AgreeProcessingComponent.vue";
import CallPopupComponent from "./components/call-popup/CallPopupComponent.vue";
export default {
  name: "App",
  components: {
    Header,
    MainSlider1,
    MainSlider2,
    Models,
    InStock,
    KnowMore,
    AboutUs,
    TeamComponent,
    Service,
    MobileApp,
    Advantages,
    YandexMapComponent,
    ContactFormComponent,
    FooterComponent,
    RequestFormComponent,
    PrivacyComponent,
    Offer,
    AgreeProcessingComponent,
    CallPopupComponent,
  },
};
</script>

<style lang="scss">
@import "./scss/style";
</style>
